<script>
export default {
    name: "LinkedInSvg"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="36.835" height="36.835" viewBox="0 0 36.835 36.835">
        <g id="Group_1441" data-name="Group 1441" transform="translate(-1711.055 -1204.385)">
            <g id="Ellipse_110" data-name="Ellipse 110" transform="translate(1711.055 1204.385)" fill="none" stroke="#000" stroke-width="1">
                <circle cx="18.417" cy="18.417" r="18.417" stroke="none"/>
                <circle cx="18.417" cy="18.417" r="17.917" fill="none"/>
            </g>
            <path id="Path_91" data-name="Path 91" d="M4991.518-980.082q-3.242,0-6.483,0a1.638,1.638,0,0,1-1.607-1.252,1.8,1.8,0,0,1-.046-.409q0-6.476,0-12.952a1.636,1.636,0,0,1,1.668-1.661q6.469,0,12.939,0a1.636,1.636,0,0,1,1.667,1.674q0,6.463,0,12.926a1.638,1.638,0,0,1-1.681,1.675Zm.815-2.453v-.178q0-2.007,0-4.014a1.4,1.4,0,0,1,.188-.738A1.214,1.214,0,0,1,4993.9-988a1.252,1.252,0,0,1,.867,1.242q0,2.02,0,4.041v.177h2.431c0-.05.007-.094.007-.137,0-1.476,0-2.952,0-4.428a2.955,2.955,0,0,0-.055-.609,2.789,2.789,0,0,0-1.411-1.929,2.44,2.44,0,0,0-2.856.185,7.435,7.435,0,0,0-.556.527v-.912h-2.43v7.3Zm-6.5-7.3v7.3h2.42v-7.3Zm2.67-2.851a1.471,1.471,0,0,0-1.461-1.472,1.463,1.463,0,0,0-1.462,1.46,1.447,1.447,0,0,0,1.462,1.467A1.456,1.456,0,0,0,4988.5-992.69Z" transform="translate(-3261.877 2210.98)"/>
        </g>
    </svg>
</template>
